import {  FaGithub } from "react-icons/fa";
import EnginuityCommunitySection from "./EnginuityCommunitySection";


export default function ProgramStructure() {
    const semesters = [
        {
            title: "Semester one(6 Months) - Core Engineering Foundations for Future Software Developers",
            color: "border-blue-300 bg-blue-50",
            modules: [
                {
                    code: "CM101",
                    title: "Introduction to Computer Systems",
                    description: "Introduction, OS, Hardware(Memory, Motherbord, Peripherals, CPU and more..), Software, Networking, Architecture, Security, Number System etc",
                },
                {
                    code: "CM102",
                    title: "Programing Languages and JavaScript Programming",
                    description: "JavaScript Fundamentals to Advance Topic",
                },
                {
                    code: "CM103",
                    title: "Object Oriented Analysis, Design & Programming",
                    description:
                        "OOP Principles, Encapsulation, Inheritance, Polymorphism, UML and OOP with Javascript etc",
                },
                {
                    code: "CM104",
                    title: "Data Structures & Algorithms Concept - Part One",
                    description: "Introduction to fundamental data structures and algorithms using JavaScript, focusing on arrays, searching, sorting, stacks, queues, and basic complexity analysis. Designed for non-CSE backend engineers to build a strong foundation with practical examples."
                },
                {
                    code: "CM105",
                    title: "Database Design & Programming",
                    description: <>
                        Database Design, Programming(Statements(DDL, DML etc), Index, View, join, Store Procedure, Function, triger, Error handling and more....), Design and implement Complete Trade application database that's students will gain hands-on experience by designing and developing a complete stock trading application. This includes implementing business logic using advanced MySQL features to support operations such as user authentication, order management, transaction processing, reporting, and analytics.
                        <br/><br/>
                        <span className="font-bold">Real Wrold Outcomes (DB-level Simulated)</span><br/><br/>
                        1. Mastery of MySQL Stored Procedures, Functions, Complex Joins and Subqueries, Effective Error Handling with HANDLER and Transactions, Triggers for automated tasks <br/>
                        2. Buy/Sell Order Processing<br/>
                        3. Order Matching System<br/>
                        4. Implementing Different Type of Algorithm in SQL<br/>
                        5. Reporting & Analytics Design<br/>
                        6. Secure Transaction Execution <br/>
                        7. Authentication and Authorization  <br/>
                        8. Use of Indexing for Query Optimization<br/>
                        9. Data Integrity with Foreign Keys and Constraints<br/>
                       10. First-Come, First-Served Matching Engine Logic<br/>
                       11. Concurrent Order Handling Using Isolation Levels<br/>
                       12. Logging and Auditing<br/>
                       13. Real-World Trading Simulation<br/>
                       14. Analytical Thinking in Financial Logic<br/>
                       15. Report Filtering by Time Range, Stock, and Status<br/>
                       16. Modular SQL Programming Practices<br/>
                       17. Hands-On Database Architecture Skills<br />
                       18. High-Concurrency Transaction Handling<br />
                       19. System Reliability and Data Consistency Practices<br />
                       20. Debugging and Optimizing SQL Code<br />
                       21. Ability to design and implement a complete transaction-based system
                    </>,
                },
                { code: "CM106", title: "Node.js", description: "Node Core Concept" },
                {
                    code: "CM107",
                    title: "API Design and Development",
                    description: "Learn how to design and build secure, scalable RESTful APIs using Express.js. This course covers API architecture, route handling, middleware, data validation, authentication with JWT, and best practices for versioning and error handling. Students will gain hands-on experience in building real-world APIs used in modern web and mobile applications."
                },
                {
                    code: "CM108",
                    title: "Project - Trade Application",
                    description: <>
                        This course teaches students how to build secure and scalable RESTful APIs using Node.js and Express.js. Students will apply API Design and Development(CM107) skills for developing real-world APIs for a trading application, connecting backend logic with a previously designed database system.<br/>
                        <br/>
                        <span className="font-bold"> Combined (course CM105 and CM107) Outcomes</span><br/>
                        <br/>
                        1. Backend Engineering Knowledge of Building a Trading System<br/>
                        2. Design and Implementation of Complete Business Workflows (e.g., placing, matching, executing orders)<br />
                        3. Database + Application Layer Integration with Proper Data Flow<br />
                        4. Real-World Software Engineering Skills<br />
                        5. Portfolio-Ready Project<br />
                        6. Capable of Building Transaction-Heavy, Data-Consistent Systems<br />
                        7. Strong Debugging Skills across SQL and JavaScript Backend<br />
                        8. Deployment Experience With Express + MySQL<br />
                        9. Industry-Level Coding Practices (Separation of Concerns, Modular Design)<br />
                       10. Designing Reporting & Analytics <br/>
                       11. RESTful API interaction with database <br/>
                       12. <span className="font-bold">Prepared for Roles:</span>  Backend Developer / Software Engineer (Entry to Mid-Level), Data Analyst (Bonus if you go deeper into analytics) <br />
                    </>
                }
            ],
        },
        {
            title: "Semester two(6 Months) -  Software Engineering in Action: Real-World API, Architecture & Project Delivery",
            color: "border-green-300 bg-green-50",
            modules: [
                {
                    code: "CM109",
                    title: "API Integration",
                    description: "Learn how to integrate external services and APIs into your applications using OWN SDKs and HTTP clients. This course covers real-world use cases such as integrating payment gateways, shipping providers, and third-party APIs. Students will gain hands-on experience in working with RESTful APIs, handling authentication methods like API keys and OAuth, parsing API responses, and managing errors and retries in API communication."
                },
                {
                    code: "CM110",
                    title: "Basic System Design & Architecture Concept",
                    description: "Monolithic, Layered (N-Tier), SOA, Event-Driven, Microservices Architect, API gateway, Caching, Scaling and Load Balancing",
                },
                {
                    code: "CM111",
                    title: "Project Management Basics and Tracking",
                    description: "Learn project management fundamentals with a focus on Agile methodologies, SDLC (Software Development Life Cycle), and real-world tracking tools. This course covers practical use of Trello and GitHub Projects for task and workflow management, and Git for version control and collaboration. Students will gain hands-on experience managing software development tasks from planning to deployment using lightweight, developer-friendly tools."
                },
                {
                    code: "CM112",
                    title: "Project – E-commerce Application",
                    description: (
                        <>
                            This comprehensive project enables students to design and build a full-fledged E-commerce web application using a modern technology stack — <strong>React.js for the Frontend</strong> and <strong>Node.js for the Backend</strong>. The application integrates various real-world services, including <strong>payment gateways</strong>, <strong>shipping APIs</strong>, and features a powerful <strong>Admin Panel</strong> for managing products, categories, orders, payments, and more.
                            <br /><br />
                            The entire project is structured into multiple functional modules such as Product Management, Category Management, Order Processing, and User Management. Each module is treated as an independent sub-project following the complete <strong>Software Development Life Cycle (SDLC)</strong>. Students will gain deep insights into both engineering and project workflow through the following stages:
                            <br /><br />
                            <strong>Step 1: Requirement Specification</strong><br />
                            
                            <strong>Step 2: Database Design</strong><br />
                       
                            <strong>Step 3: Prototyping</strong><br />
          
                            <strong>Step 4: High-Level Architecture Design</strong><br />
                        
                            <strong>Step 5: Low-Level Design (Use Cases)</strong><br />
                     
                            <strong>Step 6: Development</strong><br />
            
                            <strong>Step 7: Testing</strong><br />
                   
                            <strong>Step 8: Deployment</strong><br /><br />
                       
                            By completing this project, students will have built a scalable, production-ready E-commerce platform, mastering both technical skills and real-world SDLC implementation from planning to deployment. This project encompasses the full SDLC lifecycle — from requirement gathering to deployment — providing in-depth real-world software engineering experience.
                        </>
                    )
                },
                {
                    code: "CM113",
                    title: "API Security",
                    description: "Comprehensive strategies for securing RESTful APIs, including Authentication and Authorization mechanisms, Input Validation and Output Sanitization, implementation of SSL/TLS encryption, Rate Limiting and Throttling, API Versioning, protection against CSRF and XSS via CSP and CORS policies, Secure Key Management practices, safeguarding sensitive data at rest and in transit, centralized Logging and Monitoring, and continuous Vulnerability Management and Security Testing."
                },
                {
                    code: "CM114",
                    title: "CI/CD(DevSecOps)",
                    description: "This course introduces the principles and practices of Continuous Integration and Continuous Deployment (CI/CD). Students will learn how to automate build, test, and deployment pipelines using GitHub Actions. The course also covers containerization with Docker, enabling consistent development and deployment environments. By the end, students will be able to set up end-to-end CI/CD workflows for modern web applications."
                },
            ],
        }, 
        {
            title: "Software QA Engineering Foundation for Test-Focused Developers",
            color: "border-pink-300 bg-pink-50",
            modules: [
                {
                    code: "CM115",
                    title: "Software Testing & QA",
                    description: "This course covers the fundamentals of software testing with a focus on Node.js applications. Students will learn unit testing, integration testing, and manual system testing practices. It includes hands-on experience with tools such as Postman for API testing and frameworks for end-to-end (E2E) testing. The course emphasizes writing reliable test cases, understanding testing strategies, and applying best practices for ensuring software quality."
                }
            ]
        },
        {
            title: "Only Dedicated Candidate - Optional enrichment, Advanced Backend Engineering for Committed Learners",
            color: "border-yellow-200 bg-yellow-50",
            modules: [
                {
                    code: "CM116",
                    title: "Cloud & AWS",
                    description: "Explore and apply essential AWS cloud services including EC2 (Virtual Servers), S3 (Object Storage), IAM (Identity & Access Management), Lambda (Serverless Functions), ECS (Container Orchestration), ECR (Container Registry), and CloudWatch (Monitoring & Logging). Gain real-world skills for building and deploying scalable, cloud-native applications.",
                },
                {
                    code: "CM117",
                    title: "Project - Mystical STD",
                    description: (
                        <>
                            This advanced capstone project offers hands-on mastery of backend systems by building and deploying the Mystical STD platform — an open-source, microservices-based architecture built using Node.js, Express, Kafka, Redis, and AWS Cloud.<br /><br />
                            Students will gain real-world experience in:<br />
                            - Designing and structuring distributed services using Microservice Architecture<br />
                            - Setting up inter-service communication using Kafka (event-driven patterns)<br />
                            - Caching and message brokering with Redis<br />
                            - Building secure services with authentication and authorization flows<br />
                            - Implementing centralized logging and monitoring using tools like Winston, CloudWatch, etc.<br />
                            - Setting up API Gateway and service routing<br />
                            - Writing and maintaining Dockerfiles, docker-compose, and deploying using ECS<br />
                            {/* - Automating CI/CD pipelines with GitHub Actions<br /> */}
                            - Conducting infrastructure scanning, service testing, and deployment readiness checks<br />
                            - Debugging and testing services in containerized, cloud-hosted environments<br /><br />
                            By the end of this module, students will be capable of architecting, securing, testing, deploying, and scaling a complete cloud-native backend system — aligned with industry-grade engineering practices.

                            <div className="flex sm:justify-start gap-4 text-1xl text-gray-600 dark:text-gray-300 py-3">
                                <a
                                    href="https://github.com/YeasinSE/Mystical-STD"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex items-center gap-2 hover:text-purple-600"
                                >
                                    <span>See Project Details</span> <FaGithub />
                                </a>
                            </div>
                        </>
                    )
                },
                {
                    code: "CM118",
                    title: "Linux & DB Admin",
                    description: "Shell scripting, SQL admin, permissions.",
                },
                {
                    code: "CM119",
                    title: "Data Structures & Algorithms Concept - Part Two",
                    description: "Focus on linked lists, recursion, and advanced searching algorithms using JavaScript. Designed for backend engineers to deepen understanding of dynamic data structures and recursive problem solving with real-world backend applications."
                }
            ],
        },
        // {
        //     title: "Next Specialization Track - Enginuity Community Powers(critical focus)",
        //     color: "border-red-300 bg-red-50",
        //     modules: [
        //         {
        //             code: "CM120",
        //             title: "Data Engineering Concept - Project",
        //             description: "Intorduction, Analysis, Design and Implement Complete ETL Pipelines"
        //         },
        //         {
        //             code: "CM121",
        //             title: "Data Structures & Algorithms Concept - Part Three",
        //             description: "Advanced topics covering trees, graphs, complex sorting algorithms, dynamic programming, and in-depth time and space complexity analysis. Tailored for backend engineers aiming to master scalable and efficient data processing using JavaScript."
        //         },
        //     ],
        // }
    ];


    return (
        <div className="container mx-auto p-6 space-y-10">
            {/* <h1 className="text-3xl font-bold text-center mb-4">📘 Backend Software Engineering Program (Full Stack API & Cloud Specialization)</h1> */}
            <div>
                <p className="text-1xl font-bold mb-4">
                    This comprehensive program covers foundational computer science principles through advanced backend development and cloud-native architectures.
                </p>
                <p className="text-1xl mb-4">
                    <span className="font-bold ">Semester 1 </span> emphasizes core concepts such as programming with JavaScript, object-oriented design, data structures, algorithms, database development, Node.js, and API creation—culminating in a secure, scalable stock trading application.
                </p>
                <p className="text-1xl mb-4">
                    <span className="font-bold ">Semester 2 </span> advances skills in API integration, Linux and database administration, system design, project management, and includes a real-world eCommerce project. It also addresses API security and CI/CD pipelines to align with professional development practices.
                </p>
                <p className="text-1xl mb-4">
                    <span className="font-bold ">Additional Semester(Only Dedicated Candidate)</span> delivers hands-on cloud experience using AWS, microservices, Kafka, Redis, containerization, and production deployment, enabling students to build, secure, test, and scale cloud-native backend systems in a practical project and It also addresses software testing & QA, Linux Administration.
                </p>
            </div>
            {semesters.map((sem, index) => (
                <div
                    key={index}
                    className={`rounded-xl shadow-md border-l-8 p-6 ${sem.color}`}
                >
                    <h2 className="text-2xl font-semibold mb-4 text-gray-800">{sem.title}</h2>
                    <div className="overflow-x-auto">
                        <table className="min-w-full  border-collapse">
                            <thead>
                                <tr className="bg-white text-left">
                                    <th className="px-4 py-2 font-medium text-gray-600">Code</th>
                                    <th className="px-4 py-2 font-medium text-gray-600">Title</th>
                                    <th className="px-4 py-2 font-medium text-gray-600">Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sem.modules.map((mod, idx) => (
                                    <tr
                                        key={idx}
                                        className={`border-t border-gray-200 hover:bg-white transition ${['CM113', 'CM108','CM117'].includes(mod.code) ? 'bg-green-200 border border-green-500' : null}`}
                                    >
                                        <td className="px-4 py-2 text-blue-800 font-semibold">{mod.code}</td>
                                        <td className="px-4 py-2 text-gray-800">{mod.title}</td>
                                        <td className="px-4 py-2 text-gray-600">{mod.description}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            ))}
           
           <EnginuityCommunitySection />
           
        </div>
    );
}
